<script setup>
import { Button } from '@dashhudson/dashing-ui/button';
import { Panel } from '@dashhudson/dashing-ui/panel';
import { useRoute, useRouter } from 'vue-router';

const route = useRoute();
const router = useRouter();

const connectSalesforce = () => {
  const callbackUri = `${window.location.origin}${
    router.resolve({ name: 'community-salesforce-integration-activation-callback' }).href
  }`;
  const authUrl = `${route.query.login_url}/services/oauth2/authorize?response_type=code&client_id=${route.query.client_id}&redirect_uri=${callbackUri}`;
  window.open(authUrl, 'sf_oauth', 'width=800,height=600');
};
</script>

<template>
  <div class="dash-h-full">
    <Panel title="Connect your Salesforce account" :collapsable="false">
      <p>
        Dash Social needs access to your Salesforce account to display and respond to community
        social interactions
      </p>
      <Button
        label="Connect Salesforce"
        severity="primary"
        size="lg"
        class="dash-mt-6"
        @click="connectSalesforce()"
      />
    </Panel>
  </div>
</template>
